module.exports = __webpack_public_path__ + "static/media/points-icon-battles-small.13d05139.png";